module.exports = __webpack_public_path__ + "static/img/delete01.da07a8e0.svg";